import { FormatHelper } from '../../helpers/FormatHelper';
import { OrderForListing } from '../../models/OrderForListing';
import { InformationPopover } from './InformationPopover';

interface IClientDeadlineCellProps {
  orderForListing: OrderForListing;
  clientDeadline: string;
}

export const ClientDeadlineCell: React.FC<IClientDeadlineCellProps> = ({
  orderForListing,
  clientDeadline
}) => {

const isPreSale = orderForListing?.order?.totalPreOrderItemsCount && orderForListing?.order?.totalPreOrderItemsCount > 0;

return <>
    <span>{clientDeadline}</span>
    <InformationPopover 
      text={FormatHelper.formatDate(orderForListing?.order?.currentDeliveryDeadlineDate) + (isPreSale ? ' - pré-venda' : '')}
      color={isPreSale ? 'orange' : 'gray'}
    />
  </>;
}